import React, { Component } from "react";
import styled from 'styled-components';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  Legend,
  ResponsiveContainer,
  Text
} from 'recharts';

import Teams from "../../../api/Teams";

import { ContentContainerWithBackground } from '../components/ui';

const ChartTitle = styled.h2`
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 12px;
  color: rgba(0, 27, 59, 0.94);
  text-transform: capitalize;
`;

const LineLabel = (props) => {
  const { x, y, fill, value } = props;

  return (
    <g style={{ backgroundColor: '#fff' }}>
      <text
        x={x}
        y={y}
        dy={-14}
        style={{
          fill: fill,
          fontWeight: 500
        }}
        fontSize={10}
        textAnchor="middle"
      >
        {value}
      </text>
      <line x1={x} y1={y - 2} x2={x} y2={y - 10} stroke="#F1F1F1" />
    </g>
  );
};

const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
  const isVert = axisType === "yAxis";
  const cx = isVert ? x : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + 10;
  const rot = isVert ? "270 0 0" : 0;

  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(${rot})`}
      textAnchor="middle"
      stroke={stroke}
    >
      {children}
    </text>
  );
};

const XAxisTicker = ({
  payload,
  x,
  y,
  ...rest
}) => {

  const regex = /(?![^\n]{1,20}$)([^\n]{1,20})\s/g;
  const labelRows = payload.value.split(regex).filter(i => i !== '');

  const labelRowHeight = 14;
  const labelsToDisplay = labelRows.map((str, index) => {
    const newRowShift = index * labelRowHeight;
    return <Text y={y + newRowShift} x={x} {...rest}>{str}</Text>;
  })
  return (
    <g>
      {labelsToDisplay}
    </g>
  );
}

class AssessmentChart extends Component {
  render() {
    const { data } = this.props;
    return (
      <ContentContainerWithBackground>
        <ChartTitle>Self-Assessment</ChartTitle>
        <ResponsiveContainer width={672} height={400}>
          <LineChart
            data={data}
            margin={{ bottom: 20, right: 10 }}
          >
            <XAxis
              dataKey="question"
              padding={{ left: 50, right: 10 }}
              axisLine={false}
              tickLine={false}
              tickCount={data.length}
              interval={0}
              tick={props => XAxisTicker(props)}
              cx="10"
              cy="0"
              style={{
                fontWeight: 700,
                fill: "rgba(0, 27, 59, 0.6)"
              }}
            />
            <YAxis
              tickLine={false}
              tickFormatter={(value) => value.toFixed(2)}
              label={
                <AxisLabel axisType="yAxis" x={-210} y={10} height={0}>
                  Rating
                </AxisLabel>
              }
              style={{
                fontWeight: 700
              }}
              padding={{ top: 20 }}
            />
            <Tooltip />
            <Legend
              verticalAlign="top"
              iconType="plainline"
              iconSize={15}
              formatter={(value, entry, index) => <span style={{ fontSize: 12 }}>{value}</span>}
              margin={{ top: 15, left: 0, right: 0, bottom: 0 }}
            />
            <Line
              type="monotone"
              dataKey="Self-Assessment"
              stroke={Teams.currentTeamColor()}
              strokeWidth={3}
              dot={false}
              activeDot={false}
            >
              <LabelList content={<LineLabel fill={Teams.currentTeamColor()} />} />
            </Line>
            <Line
              type="monotone"
              dataKey="Team-Assessment"
              stroke="#2A4169"
              dot={false}
              activeDot={false}
            >
              <LabelList content={<LineLabel fill='#2A4169' />} />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </ContentContainerWithBackground>
    );
  }
}

export default AssessmentChart;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/assessment-chart.js